import { formActionTypes as actionTypes } from "../ActionTypes/formActionTypes";
import commonActions from "./commonActions";
import formHelpers from "../Utils/Form/formUtils";

const formActions = {

    startFormEditing(id, data, validationRules, fieldTypes) {
        return (dispatch, getState) => {
            dispatch({
                type: actionTypes.START_FORM_EDITING,
                id,
                data,
                validationRules,
                fieldTypes,
                fieldErrorFlags: {}
            });

            const updatedForm = getState().FormReducer.forms[id];
            const validationResult = formHelpers.validateForm(updatedForm);
            
            dispatch({
                type: actionTypes.UPDATE_FORM_VALIDITY,
                id: id,
                valid: !validationResult
            });
        };
    },
    
    
    cancelFormEditing(formId, callback) {
        return dispatch => {
            dispatch({type: actionTypes.CANCEL_FORM_EDITING, formId});

            if (callback) {
                callback();
            }
        }
    },

    submitForm(form, onSubmit) {
        return (dispatch) => {
            const validationResult = formHelpers.validateForm(form);
            
            const updatedFieldErrorFlags = { ...form.fieldErrorFlags };
            Object.keys(validationResult || {}).forEach((field) => {
                if (!updatedFieldErrorFlags[field]) {
                    updatedFieldErrorFlags[field] = validationResult[field];
                }
            });
            
            dispatch(formActions.setFormValidity(form.id, updatedFieldErrorFlags));

            if (Object.keys(updatedFieldErrorFlags).length === 0) {
                onSubmit();
            } else {
                dispatch(commonActions.showError(null, 'Please validate!'));
            }
        };
    },
    
    changeMultiFormField(form, field, value) {
        return (dispatch, getState) => {
            dispatch({
                type: actionTypes.CHANGE_FIELD_VALUE,
                id: form.id,
                field,
                value
            });
            
            if (form.fieldErrorFlags && form.fieldErrorFlags[field]) {
                const updatedForm = getState().FormReducer.forms[form.id];
                dispatch(formActions.validateField(updatedForm, field));
            }
        }
    },
    
    changeAndValidateMultiFormField(form, field, value) {
        return (dispatch, getState) => {
            dispatch(formActions.changeMultiFormField(form, field, value));

            const updatedForm = getState().FormReducer.forms[form.id];

            dispatch(formActions.validateField(updatedForm, field));
        }
    },

    validateField(form, field) {
        return (dispatch) => {
            let fieldErrorFlag = formHelpers.validateField(form, field);
            dispatch(formActions.updateFieldErrorFlags(form, field, fieldErrorFlag));
        };
    },
    
    updateFieldErrorFlags(form, field, errorFlag) {
        return (dispatch) => {
            const updatedFieldErrorFlags = { ...form.fieldErrorFlags };
            
            if (errorFlag && Object.keys(errorFlag).length > 0) {
                updatedFieldErrorFlags[field] = errorFlag[field];
            } else {
                delete updatedFieldErrorFlags[field];
            }

            dispatch(formActions.setFormValidity(form.id, updatedFieldErrorFlags));
        };
    },
    
    setFormValidity(id, fieldErrorFlags) {
        return {
            type: actionTypes.UPDATE_FORM_VALIDITY,
            id: id,
            valid: !fieldErrorFlags || Object.keys(fieldErrorFlags).length === 0,
            fieldErrorFlags: fieldErrorFlags
        };
    },
    
    updateFormValidationRules(formId, newValidationRules) {
        return (dispatch, getState) => {
            dispatch({
                type: actionTypes.UPDATE_FORM_VALIDATION_RULES,
                id: formId,
                validationRules: newValidationRules
            });

            const updatedForm = getState().FormReducer.forms[formId];
            if (updatedForm) {
                const validationResult = formHelpers.validateForm(updatedForm);
                const isEmpty = validationResult && Object.keys(validationResult)?.length === 0;
                dispatch({
                    type: actionTypes.UPDATE_FORM_VALIDITY,
                    id: formId,
                    valid: isEmpty,
                });
            }
        };
    },
}

export default formActions;